module.exports = __webpack_public_path__ + "static/media/sub_lit.65943c92.png";